import * as React from "react";
import * as ReactDOM from "react-dom";
import { toODataString } from "@progress/kendo-data-query";
import { ResolveBaseApiUrl } from "./Utility";
import store from "../store";

export const DataLoader = (props) => {
  //debugger;
  let page_no = "";
  let ControllerName = "";
  let ActionName = "";
  let sorting_field = "";
  let sorting_order = "";
  let searchItem = false;
  let sortItem = false;
  let Search_Field = "";
  let Mandatory_Field = "";
  var filterParam = "";

  ControllerName = props.dataItem.ControllerName;
  ActionName = props.dataItem.ActionName;
  Search_Field = props.dataItem.SearchField;
  Mandatory_Field = props.dataItem.MandatoryField;
  searchItem = localStorage.getItem("searchData");
  sortItem = localStorage.getItem("sortData");

  if (props.dataState.skip === 0) page_no = "1";
  else if (props.dataState.skip === 50) page_no = "2";
  else page_no = props.dataState.skip / 50 + 1;
  let page_size = "50";
  let mandatoryFilter =
    props.dataState.mandatoryFilter == undefined
      ? "0"
      : props.dataState.mandatoryFilter;

  sorting_field = props.dataSort[0].field;
  sorting_order = props.dataSort[0].dir;

  var searchData =
    props.dataState.filter === "0" ||
    props.dataState.filter === "1" ||
    props.dataState.filter === null
      ? ""
      : props.dataState.filter;

  var advfilterdata = JSON.stringify(props.dataState.filter);
  if (advfilterdata.indexOf("isAdvanceSearch") !== -1) {
    if (ControllerName === "Reports") {
      filterParam = {
        pageNo: "" + page_no + "",
        pageSize: "" + page_size + "",
        sortingField: "" + sorting_field + "",
        sortingOrder: "" + sorting_order + "",
        order_end_date_start_range:
          "" + props.dataState.filter.completion_start_date + "",
        order_end_date_end_range:
          "" + props.dataState.filter.completion_end_date + "",
        order_applicant_name: "" + props.dataState.filter.applicant_name + "",
        report_id: ""+props.dataState.filter.report_id,
        investigator_id: "" + mandatoryFilter,
        
        //customer_name: "" + props.dataState.filter.applicant_name + "",
        //requestor_name: "" + props.dataState.filter.applicant_name + ""
      };
    } else {
      filterParam = {
        pageNo: "" + page_no + "",
        pageSize: "" + page_size + "",
        sortingField: "" + sorting_field + "",
        sortingOrder: "" + sorting_order + "",
        submission_start_date:
          "" + props.dataState.filter.submission_start_date + "",
        submission_end_date:
          "" + props.dataState.filter.submission_end_date + "",
        completion_start_date:
          "" + props.dataState.filter.completion_start_date + "",
        completion_end_date:
          "" + props.dataState.filter.completion_end_date + "",
        applicant_name: "" + props.dataState.filter.applicant_name + "",
        investigator_id: "" + mandatoryFilter,
        status: props.dataState.filter.status,
      };
    }
  } else {
    filterParam = {
      pageNo: "" + page_no + "",
      pageSize: "" + page_size + "",
      sortingField: "" + sorting_field + "",
      sortingOrder: "" + sorting_order + "",
    };
    filterParam[Search_Field] = searchData;
    if (ControllerName === "Customer") {
      filterParam["archived"] = props.dataArchived ? "1" : "0";
    }
    if (Mandatory_Field != null)
      filterParam[Mandatory_Field] = props.dataState.mandatoryField;
    //console.log("Filter Params " + JSON.stringify(filterParam));
  }
  //console.log("Final Filter Params " + JSON.stringify(filterParam));
  const baseUrl = ResolveBaseApiUrl() + ControllerName + "/" + ActionName;
  const requestOptions = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${store.getState().auth.token}`,
    },
    body: JSON.stringify(filterParam),
  };
  const lastSuccess = React.useRef("");
  const pending = React.useRef("");

  const requestDataIfNeeded = () => {
    if (
      (pending.current ||
        toODataString(props.dataState) === lastSuccess.current) &&
      (searchItem === undefined || searchItem === "false") &&
      (sortItem === undefined || sortItem === "false")
    ) {
      //console.log("Return");
      localStorage.setItem("searchData", false);
      localStorage.setItem("sortData", false);
      return;
    }
    pending.current = toODataString(props.dataState);
    fetch(baseUrl, requestOptions)
      .then((response) => response.json())
      .then((json) => {
        if (ControllerName === "Customer") {
          json = json.map((dataItem) =>
            Object.assign(
              {
                selected: false,
              },
              dataItem
            )
          );
        }
        lastSuccess.current = pending.current;
        pending.current = "";
        if (toODataString(props.dataState) === lastSuccess.current) {
          let ttlRows = json.length > 0 ? (
            json[0].totalRows == undefined
              ? json[0].total_rows
              : json[0].totalRows) : 0;
          props.onDataReceived.call(undefined, {
            data: json,
            total: json.length > 0 ? ttlRows : 0,
          });
          //console.log(json);
          localStorage.setItem("searchData", false);
          localStorage.setItem("sortData", false);
        } else {
          requestDataIfNeeded();
        }
      });
  };
  requestDataIfNeeded();
  return pending.current ? <LoadingPanel /> : null;
};
const LoadingPanel = () => {
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );
  const gridContent = document && document.querySelector(".k-grid-content");
  return gridContent
    ? ReactDOM.createPortal(loadingPanel, gridContent)
    : loadingPanel;
};
